<script setup lang="ts">
import { onMounted } from "vue";
import { HousingSiteResult } from "~/api";
import { useHousingOrgStore } from "~/YYC_Housing/stores/HousingOrgStore";
import { useHousingSiteStore } from "~/YYC_Housing/stores/HousingSiteStore";

const props = defineProps<{
  locationsSelected: HousingSiteResult[];
  // When rendered inside narrow containers, use singleColumn to stack and
  // left-align titles for better readability.
  singleColumn?: boolean;
}>();

const housingSiteStore = useHousingSiteStore();
const housingOrgStore = useHousingOrgStore();

onMounted(async () => {
  await Promise.all([housingOrgStore.load(), housingSiteStore.load()]);
});
</script>
<template>
  <div
    class="ApplicationLocationPreferences"
    :class="{ 'single-column': props.singleColumn }"
  >
    <span class="locations-text">
      {{ locationsSelected.length }} location{{
        locationsSelected.length === 1 ? "" : "s"
      }}
    </span>
    <div
      v-for="site in [...locationsSelected].sort((a, b) =>
        (a.hmb ?? '').localeCompare(b.hmb ?? ''),
      )"
      :key="site.siteCode"
      class="location summary"
    >
      <div class="location-header">
        <h3>
          {{ housingOrgStore.getNameByCode(site.hmb) }}
        </h3>
        <h2 class="location-title">
          {{ housingSiteStore.getSite(site.siteCode)?.name ?? site.siteCode }}
        </h2>
      </div>
    </div>
  </div>
</template>
<style lang="less">
.ApplicationLocationPreferences {
  width: 100%;

  .location {
    margin-bottom: 0.2em;
  }

  .location.summary {
    border: none;
    background: transparent;
    padding: 0;

    .location-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1em;
      border-bottom: 1px solid #ddd;

      h2,
      h3 {
        font-size: inherit;
        color: var(--el-text-color-primary);
      }
    }
  }

  &.single-column {
    .locations-text {
      color: var(--el-text-color-secondary);
    }

    .location.summary .location-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 0;
      border-bottom: 1px solid var(--el-border-color-lighter);
      padding: 0.25em 0;

      h3 {
        font-size: inherit;
        font-weight: 400;
        color: var(--el-text-color-secondary);
        margin: 0;
      }

      h2 {
        font-size: inherit;
        font-weight: 500;
        margin: 0;
      }
    }
  }
}
</style>
